import React from 'react';

function Content({children}) {
    return (
        <div className="content" style={{padding: '20px'}}>
           {children}
        </div>
    );
}

export default Content;